const noop = function noop2() {
};

export { noop };
/*                              */
